// ** Styles
import { useCallback, useEffect, useState } from 'react';
import '@styles/react/apps/app-roads.scss';
import { Link, useParams } from 'react-router-dom';
import {
  GetActivityById,
  listUsersByActivity
} from '../../../graphql/Mutation';
import { useMutation, useQuery } from '@apollo/client';
import Avatar from '@components/avatar';
import DownloadButton from './DownloadButton';
import Flatpickr from 'react-flatpickr';
import '@styles/react/libs/charts/apex-charts.scss';
import '@styles/react/libs/flatpickr/flatpickr.scss';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import moment from 'moment';

import Grupo508 from '../../../assets/images/Grupo508.png';

const FIELDS = {
  video: ['status', 'name', 'description', 'video', 'type'],
  form: ['status', 'name', 'description', 'form', 'type'],
  friends: ['status', 'name', 'description', 'friends', 'type'],
  audio: ['status', 'name', 'description', 'audio', 'type', 'cover'],
  checklist: ['status', 'name', 'description', 'list', 'type'],
};

const renderClient = (row) => {
  return (
    <Avatar
      initials
      className="me-1"
      color={'light-primary'}
      content={row.fullName || ''}
    />
  );
};

const renderType = (row) => {
  const typeColor = {
    video: {
      primary: '#14E4ED',
      secondary: '#E8FEFF',
      text: 'Video'
    },
    audio: {
      primary: '#EB36B4',
      secondary: '#FFEBF9',
      text: 'Audio'
    },
    friends: {
      primary: '#EDC314',
      secondary: '#FFF8E8',
      text: 'Amigos'
    },
    form: {
      primary: '#7139F0',
      secondary: '#EFE8FF',
      text: 'Formulario'
    },
    checklist: {
      primary: '#7139F0',
      secondary: '#EFE8FF',
      text: 'Formulario'
    }
  };

  const Div = () => (
    <div
      style={{
        color: typeColor[row.type].primary,
        background: `${
          typeColor[row.type].secondary
        } 0% 0% no-repeat padding-box`,
        padding: '2.5px 16px',
        borderRadius: '11px',
        fontWeight: 'bold',
        display: 'table'
      }}
    >
      {typeColor[row.type].text}
    </div>
  );

  return (
    <span className="text-left">
      <Div />
    </span>
  );
};

const renderTypeInfo = (data) => {
  return (
    <div className="card">
      <div
        className="card-header"
        style={{ borderBottom: '1px solid #d5d7da' }}
      >
        <div className="card-title">
          {moment(data?.finishedAt).format('D [de] MMMM YYYY - HH:mm')}
        </div>
      </div>
      {(data?.type === 'video' || data?.type === 'audio') && (
          <div>
            <div className="row col-12 m-0 p-1">
              <div className="nunDataResponse">{1}</div>
              <div className="col row m-0">
                <div className="name_friends col-12">
                  {data?.type === 'video'
                    ? 'Visualizó el video'
                    : 'Se reprodujo el audio'}
                </div>
                <div className="text_friends col-12">
                  {moment(data?.reminder).utc().format('D [de] MMMM YYYY - HH:mm')}
                </div>
              </div>
            </div>
          </div>
        )}

      {data?.type === 'friends' && data?.leadFriends.map((info, i) => {
            return (
              <div key={i} className="row col-12 m-0 p-1">
                <div className="nunDataResponse">{i + 1}</div>
                <div className="col row m-0">
                  <div className="name_friends col-12">{info.fullName}</div>
                  <div className="text_friends col-12">{info.response}</div>
                </div>
              </div>
            );
          })
      }
      {data?.type === 'form' && data?.leadForm.map((info, i) => {
            const question = info?.form;
            return (
              <div key={i} className="row col-12 m-0 p-1">
                <div className="nunDataResponse">{i + 1}</div>
                <div className="col row m-0">
                  <div className="name_friends col-12">
                    {question[0].question}
                  </div>
                  <div className="text_friends col-12">{info.response}</div>
                </div>
              </div>
            );
          })
      }

      {data?.type === 'checklist' && data?.leadList.map((info, i) => {            
            return (
              <div key={i} className="row col-12 m-0 p-1">
                <div className="nunDataResponse">{i + 1}</div>
                <div className="col row m-0">
                  <div className="name_friends col-12">
                    {info}
                  </div>                  
                </div>
              </div>
            );
          })
      }

      {!data && (
        <div style={{ display: 'table', margin: '200px auto' }}>
          <img src={Grupo508} style={{ width: '355px', height: '302px' }} />
          <div>
            <div
              style={{
                letterSpacing: '0px',
                color: '#6D6B7B',
                fontSize: '16px',
                lineHeight: '21px',
                fontWeight: 'bold',
                textAlign: 'center'
              }}
            >
              No hay datos que mostrar
            </div>
            <div
              style={{
                letterSpacing: '0px',
                color: '#6D6B7B',
                fontSize: '16px',
                lineHeight: '21px',
                textAlign: 'center'
              }}
            >
              Intenta con otra fecha
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ResponseActivity = () => {
  const { id } = useParams();
  const [getActivityById] = useMutation(GetActivityById);
  const [loading, setLoading] = useState(true);
  const [activity, setActivity] = useState();
  const [selecteInfo, setSelecteInfo] = useState();
  const [day, setDate] = useState('');
  const {
    data,
    loading: loadingData,
    refetch
  } = useQuery(listUsersByActivity, {
    variables: {
      input: {
        activityId: id,
        date: day !== '' ? moment(day[0]).format('YYYY-MM-DD') : undefined,
        finishDate: day !== '' ? moment(day[1]).format('YYYY-MM-DD') : undefined,
      }
    },
    fetchPolicy: "no-cache" 
  });
  const list = data?.listUsersByActivity || [];
  const formatData = (data) => {
    const formatedData = {};
    FIELDS[data.type].map((key) => {
      formatedData[key] = data[key];
    });
  };

  const handleFetch = useCallback(async () => {
    try {
      setLoading(true);
      const {
        data: { getActivityById: data }
      } = await getActivityById({ variables: { activityId: id } });
      setActivity(data);
      formatData(data);
      setLoading(false);
    } catch (e) {}
  }, []);

  useEffect(() => {
    handleFetch();
  }, [handleFetch]);

  useEffect(() => {
    if (list.length > 0) {
      setSelecteInfo(list[0]);
    }
  }, [list]);

  useEffect(() => {
    refetch();
  }, [day]);

  return (
    <div className="row col-12">
      <div className="col-1">
        <Link to={`/roads/activities/list`}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={28}
            height={28}
            viewBox="0 0 28 28"
            style={{ float: 'left', marginRight: '10px' }}
          >
            <g id="arrow-down-circle" transform="translate(28) rotate(90)">
              <path
                id="Trazado_1"
                data-name="Trazado 1"
                d="M14,26.25A12.25,12.25,0,1,0,1.75,14,12.25,12.25,0,0,0,14,26.25ZM14,28A14,14,0,1,0,0,14,14,14,0,0,0,14,28Z"
                fill="#191c1d"
                fillRule="evenodd"
              />
              <path
                id="Trazado_2"
                data-name="Trazado 2"
                d="M10.381,17.13a.875.875,0,0,1,1.239,0l4.63,4.632,4.631-4.632a.876.876,0,1,1,1.239,1.239l-5.25,5.25a.875.875,0,0,1-1.239,0l-5.25-5.25a.875.875,0,0,1,0-1.239Z"
                transform="translate(-2.25 -3.749)"
                fill="#191c1d"
                fillRule="evenodd"
              />
              <path
                id="Trazado_3"
                data-name="Trazado 3"
                d="M17.75,10.125a.875.875,0,0,1,.875.875v8.75a.875.875,0,0,1-1.75,0V11A.875.875,0,0,1,17.75,10.125Z"
                transform="translate(-3.75 -2.25)"
                fill="#191c1d"
                fillRule="evenodd"
              />
            </g>
          </svg>
          <div
            style={{
              textAlign: 'center',
              letterSpacing: '0px',
              color: '#191C1D',
              fontSize: '16px',
              fontWeight: 'bold',
              float: 'left'
            }}
          >
            Atrás
          </div>
        </Link>
      </div>
      {!loading && !loadingData ? (
        <div className="col row">
          <div className="col-12">
            <div
              className="card row"
              style={{ flexDirection: 'row', marginLeft: 0, marginRight: 0 }}
            >
              <div className="col">
                <div className="card-header">
                  <div className="card-title">{activity?.name}</div>
                </div>
                <div className="card-body">{renderType(activity)}</div>
              </div>

              <DownloadButton
                dataArray={list}
                fileName={`${activity?.name}-${
                  day !== ''
                    ? moment(day[0]).format('YYYY-MM-DD')
                    : moment().format('YYYY-MM-DD')
                }.xlsx`}
              />
            </div>
          </div>
          <div className="col-3">
            <div className="picker_response">
              <div className="icon_one">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="calendar-check-fill"
                  width={20}
                  height={20}
                  viewBox="0 0 20 20"
                >
                  <path
                    id="Trazado_112"
                    data-name="Trazado 112"
                    d="M5,.625a.625.625,0,1,0-1.25,0V1.25H2.5A2.5,2.5,0,0,0,0,3.75V5H20V3.75a2.5,2.5,0,0,0-2.5-2.5H16.25V.625a.625.625,0,1,0-1.25,0V1.25H5ZM0,6.25H20V17.5A2.5,2.5,0,0,1,17.5,20H2.5A2.5,2.5,0,0,1,0,17.5Zm13.567,4.817a.626.626,0,1,0-.885-.885L9.375,13.491,7.942,12.058a.626.626,0,0,0-.885.885l1.875,1.875a.625.625,0,0,0,.885,0l3.75-3.75Z"
                    fill="#757488"
                    fillRule="evenodd"
                  />
                </svg>
              </div>
              <Flatpickr
                value={day}
                id="range-picker"
                className="form-control dateResponce"
                onChange={(date) => {
                  console.log(date);
                  if (date.length === 2) {
                    setDate(date);
                  }
                  //
                }}
                placeholder="Cualquier fecha"
                options={{
                  locale: Spanish,
                  defaultDate: moment().toDate(),
                  mode: "range"
                }}
              />
              <div className="icon_two">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="7.439"
                  height="4.462"
                  viewBox="0 0 7.439 4.462"
                >
                  <path
                    id="arrow-down-b"
                    d="M6.817,11.824l.042.049,3.162,3.638a.588.588,0,0,0,.446.2.6.6,0,0,0,.446-.2l3.159-3.632.054-.061a.358.358,0,0,0,.063-.2.377.377,0,0,0-.386-.367H7.136a.377.377,0,0,0-.386.367.354.354,0,0,0,.067.207Z"
                    transform="translate(-6.75 -11.249)"
                    fill="#757488"
                  />
                </svg>
              </div>
            </div>

            <div
              style={{
                maxHeight: '575px',
                overflowY: 'auto',
                overflowX: 'hidden'
              }}
            >
              {list.map((e) => {
                const { user, reminder} = e;
                
                return (
                  <div
                    key={e._id}
                    className="d-flex justify-content-left align-items-center active"
                    style={{
                      padding: '20px',
                      borderBottom: '1px solid #d5d7da',
                      cursor: 'pointer',
                      background: e._id === selecteInfo?._id ? '#EFEDFF' : 'transparent'
                    }}
                    onClick={() => setSelecteInfo(e)}
                  >
                    {renderClient(user)}
                    <div className="d-flex flex-column">
                      <div className="user_name text-truncate text-body">
                        <span className="fw-bolder">
                          {user?.fullName || 'No completado'}
                        </span>
                      </div>
                      <small className="text-truncate text-muted mb-0">
                        {user.email}
                      </small>
                      <small className="text-truncate text-muted mb-0">
                        {moment(reminder).utc().format('D [de] MMMM YYYY - HH:mm')}
                      </small>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="col">
            <div className="card">{renderTypeInfo(selecteInfo)}</div>
          </div>
        </div>
      ) : (
        <>loading</>
      )}
    </div>
  );
};

export default ResponseActivity;
